import ConfirmModal from "components/shared-components/ConfirmModal";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { TYPE_INVOICE_ANOTHER } from "constants/IssueInvoiceConstant";
import { numberWithCommas } from "helpers/utils";
import jwt_decode from "jwt-decode";
import {
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "pages/IssueInvoice/utils";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Col, Row } from "reactstrap";
import {
  listIssueInvoice,
  releaseIssueInvoice,
  resetListIssueInvoice,
  resetReleaseIssueInvoice,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
} from "store/auth/login/actionTypes";
import {
  RELEASE_ISSUE_INVOICE_FAIL,
  RELEASE_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import DetailInvoice from "./DetailInvoice";

const ListInvoice = props => {
  const { filterList } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["issueInvoice"]);
  const { addToast } = useToasts();

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingList,
    errorList,
    list: issueInvoiceList,
    fileDownload,
    fileDownloadName,
    type,
    deleteInvoice,
    cancelInvoice,
    successClone,
    releaseIssueInvoice: releaseInvoiceTotal,
  } = issueInvoice;

  useEffect(() => {}, [t]);

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  const [pageView, setPageView] = useState(null);

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);

  // Confirm Export modal
  const [modalConfirmExport, setModalConfirmExport] = useState(false);
  const toggleConfirmExportModal = () =>
    setModalConfirmExport(!modalConfirmExport);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, type: typeDashboard } = Dashboard;
  const history = useHistory();

  const queryData = () => {
    dispatch(
      listIssueInvoice(
        issueInvoiceList.params,
        TYPE_INVOICE_ANOTHER.INVOICE_TOTAL
      )
    );
  };

  useEffect(() => {
    switch (type) {
      case RELEASE_ISSUE_INVOICE_SUCCESS:
        addToast(t("form.submit.export.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmExportModal();
        toggleDetailModal();
        resetDataFunc();
        dispatch(resetReleaseIssueInvoice());
        break;
      case RELEASE_ISSUE_INVOICE_FAIL:
        addToast(t("form.submit.export.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetReleaseIssueInvoice());
        break;
      default:
        break;
    }
  }, [type]);

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    issueInvoiceList.params.page = 1;
    issueInvoiceList.params.sizePerPage = 10;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };

    initColumn();
    return () => {
      dispatch(resetListIssueInvoice());
    };
  }, [dispatch, t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (issueInvoiceList) {
      setColumnsTable(initColumns);
    }

    if (issueInvoiceList.columnsVisibleHaveCode) {
      initColumn();
    }
  }, [issueInvoiceList]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);

  // Action Dispatch
  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
    }
  }, []);

  // Error Dispatch
  useEffect(() => {
    if (errorList && errorList.message) {
      addToast(errorList.message, {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListIssueInvoice());
    }
  }, [addToast, dispatch, errorList, t]);

  useEffect(() => {
    switch (type) {
    }
  }, [type]);

  const initColumn = () => {
    if (issueInvoiceList.columnsVisible) {
      for (const item of initColumns) {
        if (issueInvoiceList.columnsVisible[item.dataField] !== undefined) {
          item.hidden = !issueInvoiceList.columnsVisible[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    // dispatch(setListVATInvoiceHaveCodeColumn(field, value));
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    issueInvoiceList.params.sort = sortField
      ? sortOrder + sortField
      : issueInvoiceList.params.sort;
    issueInvoiceList.params.columnFilter =
      { ...columnFilter, ...filterList } || {};
    issueInvoiceList.params.page = page || 1;
    issueInvoiceList.params.sizePerPage = sizePerPage || 10;
    queryData();
  };

  const onSearchAllHandle = value => {
    issueInvoiceList.params.keywords = value;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };
    queryData();
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    // switch (modeSet) {
    //   case issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL:
    //   case issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL:
    //   case issueInvoiceModeList.EDIT_VAT_INVOICE_DETAIL:
    //   case issueInvoiceModeList.EDIT_SALE_INVOICE_DETAIL:
    //     issueInvoiceList.params.page = 1;
    //     issueInvoiceList.params.sizePerPage = 10;
    //     issueInvoiceList.params.columnFilter = {
    //       ...issueInvoiceList.params.columnFilter,
    //       ...filterList,
    //     };
    //     queryData();
    //     break;
    //   default:
    //     break;
    // }
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      setPageViewByRow(row);
      setDataDetail({
        id: row.id,
        bu_code: row.bu_code,
        cus_code: row.cus_code,
        invoice_template_code: row.invoice_template_code,
        serial: row.serial,
        tax_type_code: row.tax_type_code,
        from_date: filterList["filter[invoice_date][gte]"],
        to_date: filterList["filter[invoice_date][lte]"],
        is_pos: row.is_pos,
      });
      setTransferData({
        bu_code: row.bu_code,
        cus_code: row.cus_code,
        invoice_template_code: row.invoice_template_code,
        serial: row.serial,
        tax_type_code: row.tax_type_code,
        from_date: filterList["filter[invoice_date][gte]"],
        to_date: filterList["filter[invoice_date][lte]"],
        is_pos: row.is_pos,
      });
      switch (row.ttchung_khmshdon) {
        case "1":
          setMode(issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL);
          break;
        case "2":
          setMode(issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL);
          break;
        default:
          break;
      }
      toggleDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-send font-size-18 text-success" />,
      text: "Xuất hóa đơn tổng",
      onClick: row => {
        const data = {
          bu_code: row.bu_code,
          cus_code: row.cus_code,
          invoice_template_code: row.invoice_template_code,
          serial: row.serial,
          tax_type_code: row.tax_type_code,
          from_date: filterList["filter[invoice_date][gte]"],
          to_date: filterList["filter[invoice_date][lte]"],
        };
        setDataDetail(data);
        setTransferData(data);
        toggleDetailModal();
      },
    },
  ];

  const setPageViewByRow = row => {
    let pageView = "";
    if (row.invoice_type)
      switch (row.ttchung_khmshdon) {
        // Hóa đơn GTGT
        case "1":
          switch (row.invoice_type) {
            case "1":
              pageView = issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        // Hóa đơn Bán hàng
        case "2":
          switch (row.invoice_type) {
            case "1":
              pageView = issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = issueInvoicePageViewList.PAGE_SALE_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    setPageView(pageView);
  };

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "cus_code",
      text: "Mã khách hàng",
      sort: true,
    },
    {
      dataField: "invoice_template_code",
      text: "Mẫu số hóa đơn",
      sort: true,
      formatter: (cell, row) => {
        return `${cell} - ${t(`khmhdon_list.${cell}`)}`;
      },
    },
    {
      dataField: "serial",
      text: "Ký hiệu hóa đơn",
      sort: true,
    },
    {
      dataField: "is_pos",
      text: "Loại",
      sort: true,
      formatter: (cell, row) => {
        switch (cell) {
          case 1:
            return "HĐ từ Máy tính tiền";
          case 0:
            return "HĐĐT TT78";
          default:
            break;
        }
      },
    },
    {
      dataField: "tax_type_code",
      text: "Thuế suất (%)",
      sort: true,
      formatter: (cell, row) => {
        if (row.invoice_template_code !== "2") {
          return cell;
        }
      },
    },
    {
      dataField: "tax_total",
      text: "Tổng tiền thuế",
      sort: true,
      formatter: (cell, row) => {
        return numberWithCommas(cell);
      },
    },
    {
      dataField: "payment_total",
      text: "Tổng tiền",
      sort: true,
      formatter: (cell, row) => {
        return numberWithCommas(cell);
      },
    },

    {
      dataField: "payment_total_text",
      text: "Tổng tiền bằng chữ",
      sort: true,
    },
    // {
    //   dataField: "invoice_date",
    //   text: t("table.date_created"),
    //   formatter: (cellContent, row) => tableFormateDate(row.invoice_date),
    // },
  ];

  const resetDataFunc = () => {
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };
    queryData();
  };

  return (
    <React.Fragment>
      <Row>
        {/* Modal START*/}
        <Col className="col-12">
          {/* Export modal */}
          <ConfirmModal
            isOpen={modalConfirmExport}
            titleHeader={"Xác nhận xuất hóa đơn tổng"}
            titleBody={"Hệ thống sẽ thực hiện xuất hóa đơn tổng ?"}
            isDisableButton={releaseInvoiceTotal.loading}
            onConfirm={note => {
              dispatch(
                releaseIssueInvoice(
                  null,
                  null,
                  TYPE_INVOICE_ANOTHER.INVOICE_TOTAL,
                  transferData
                )
              );
            }}
            textBtnConfirm={"Xác nhận"}
            textBtnCancel={"Đóng"}
            toggle={toggleConfirmExportModal}
          />
          {/* Detail Modal */}
          <DetailInvoice
            dataDetail={dataDetail}
            toggleConfirmExportModal={toggleConfirmExportModal}
            isOpenModal={detailModal}
            toggleModal={toggleDetailModal}
            mode={mode}
            pageView={pageView}
            // invoiceSymbolList={invoiceSymbolList.items}
          />
          {/* Hình thức ký modal */}
          {/* <TypeSignDigitalModal
            t={t}
            isOpen={modalTypeSign}
            transferData={transferData}
            toggle={toggleTypeSignModal}
            toggleUSBSignModal={toggleUSBSignModal}
            toggleHSMSignModal={toggleHSMSignModal}
          /> */}
          {/* Ký USB Modal */}
          {/* <VerifyPinUSBModal
            t={t}
            isOpen={modalUSBSign}
            downloadXmlFunc={downloadXmlIssueInvoice}
            transferData={transferData}
            resetDataFunc={resetDataFunc}
            toggle={toggleUSBSignModal}
          /> */}
          {/* Ký HSM Modal */}
          {/* <SignHSMModal
            t={t}
            isOpen={modalHSMSign}
            transferData={transferData}
            resetDataFunc={resetDataFunc}
            invoice_type={transferData?.invoice_type}
            releaseFunc={releaseIssueInvoice}
            resetReleaseFunc={resetReleaseIssueInvoice}
            toggle={toggleHSMSignModal}
          /> */}
        </Col>
        {/* Modal E N D*/}
        <Col className="col-12">
          <RemoteDataTable
            isShowSearchAll={false}
            // selectRow={selectRowCheckbox}
            // onRowsSelect={onRowsSelect}
            // expandRow={expandRowTable}
            keyField="index"
            data={issueInvoiceList.items}
            columns={columnsTable}
            page={issueInvoiceList.params.page}
            sizePerPage={issueInvoiceList.params.sizePerPage}
            totalSize={issueInvoiceList.totalCount}
            onTableChange={handleTableChange}
            onSearchAllHandle={onSearchAllHandle}
            optionShowColumnHandel={optionShowColumnHandler}
            rowEvents={rowEventsHandler}
            listMultipleRowAction={listMultipleRowAction}
            listRowAction={listRowAction}
            loading={loadingList}
          ></RemoteDataTable>
        </Col>
      </Row>
    </React.Fragment>
  );
};

ListInvoice.propTypes = {
  filterList: PropTypes.object.isRequired,
  title: PropTypes.string,
  titleManger: PropTypes.string,
};

ListInvoice.defaultProps = {
  filterList: {},
};

export default ListInvoice;
